import { apiService } from '@clarix/api-client';
import { pmsBase } from '../lib/base';
import { PMS_ENDPOINTS } from '../endpoints';
import type {
  ImportCompetenciesPayload,
  Competency,
  CompetencyListParams,
  CreateCompetencyPayload,
  UpdateCompetencyPayload,
  ImportReport,
} from '../types';

export const competenciesApi = {
  list: (params?: CompetencyListParams) =>
    apiService.get<Competency[]>(`${pmsBase()}${PMS_ENDPOINTS.COMPETENCIES}`, { params }),

  create: (data: CreateCompetencyPayload) =>
    apiService.post<Competency>(`${pmsBase()}${PMS_ENDPOINTS.COMPETENCIES}`, data),

  update: (competencyId: string, data: UpdateCompetencyPayload) =>
    apiService.put<Competency>(`${pmsBase()}${PMS_ENDPOINTS.COMPETENCIES}/${competencyId}`, data),

  delete: (competencyId: string) =>
    apiService.delete<void>(`${pmsBase()}${PMS_ENDPOINTS.COMPETENCIES}/${competencyId}`),

  /**
   * CSV import — returns a row-level validation report.
   *
   * JSON, NOT a multipart upload. This posted `FormData` with a `file` field
   * until 2026-08-06, and pms-api mounts only `express.json` /
   * `express.urlencoded` with no multer — so `req.body` arrived EMPTY, zod
   * defaulted `format` to 'json' with no `rows`, and every import silently
   * returned nothing behind "The server could not parse the file". No file could
   * ever have worked; the endpoint has always wanted `csv_text`.
   *
   * The xlsx parser stays at the call site so it is loaded dynamically and stays
   * out of the initial bundle (06-screens.md Bulk Import).
   */
  import: (payload: ImportCompetenciesPayload) =>
    apiService.post<ImportReport>(`${pmsBase()}${PMS_ENDPOINTS.COMPETENCIES_IMPORT}`, payload),
};
